import { render, staticRenderFns } from "./DirectionEditor.vue?vue&type=template&id=4133f18d&scoped=true&"
import script from "./DirectionEditor.vue?vue&type=script&lang=js&"
export * from "./DirectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./DirectionEditor.vue?vue&type=style&index=0&id=4133f18d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133f18d",
  null
  
)

export default component.exports